<!-- #86 -->
<template>
  <Details propName="b2b_sku_upload" />
</template>
<script>
import Details from "@/views/front/order/List";
export default {
  components: {
    Details,
  },
};
</script>
